import { Row, Col, Form } from "react-bootstrap";
import CustomAutoComplete from "../../../../components/formik/CustomAutoComplete";
import Select from "react-select";

const AutotransporteFormFields = ({
  formik,
  findPermissionTypesByCoincidence,
  findAutotransportConfigByCoincidence,
  insurers,
}) => {
  const { values, errors, touched, handleChange, setFieldTouched } = formik;

  return (
    <>
      {/* Permiso SCT */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="PermSCT">
          <CustomAutoComplete
            formik={formik}
            field="PermSCT"
            label="Permiso SCT"
            searchFunction={findPermissionTypesByCoincidence}
            descriptionField="descripcion"
          />
          {touched.PermSCT && errors.PermSCT && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.PermSCT}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="NumPermisoSCT">
          <Form.Label>Número de permiso SCT</Form.Label>
          <Form.Control
            name="NumPermisoSCT"
            value={values.NumPermisoSCT || ""}
            onChange={(e) => {
              handleChange(e);
              setFieldTouched("NumPermisoSCT", true, true);
            }}
            isInvalid={touched.NumPermisoSCT && !!errors.NumPermisoSCT}
          />
          <Form.Control.Feedback type="invalid">
            {errors.NumPermisoSCT}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Identificación Vehicular */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="ConfigVehicular">
          <CustomAutoComplete
            formik={formik}
            field="ConfigVehicular"
            label="Configuración vehicular"
            searchFunction={findAutotransportConfigByCoincidence}
            descriptionField="descripcion"
          />
          {touched.ConfigVehicular && errors.ConfigVehicular && (
            <Form.Control.Feedback type="invalid" style={{ display: "block" }}>
              {errors.ConfigVehicular}
            </Form.Control.Feedback>
          )}
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="PesoBrutoVehicular">
          <Form.Label>Peso Bruto Vehicular</Form.Label>
          <Form.Control
            name="PesoBrutoVehicular"
            value={values.PesoBrutoVehicular || ""}
            onChange={handleChange}
            isInvalid={
              touched.PesoBrutoVehicular && !!errors.PesoBrutoVehicular
            }
          />
          <Form.Control.Feedback type="invalid">
            {errors.PesoBrutoVehicular}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="PlacaVM">
          <Form.Label>Placa Vehicular</Form.Label>
          <Form.Control
            name="PlacaVM"
            value={values.PlacaVM || ""}
            onChange={handleChange}
            isInvalid={touched.PlacaVM && !!errors.PlacaVM}
          />
          <Form.Control.Feedback type="invalid">
            {errors.PlacaVM}
          </Form.Control.Feedback>
        </Form.Group>

        <Form.Group as={Col} md="6" controlId="AnioModeloVM">
          <Form.Label>Año Modelo Vehículo</Form.Label>
          <Form.Control
            name="AnioModeloVM"
            value={values.AnioModeloVM || ""}
            onChange={handleChange}
            isInvalid={touched.AnioModeloVM && !!errors.AnioModeloVM}
          />
          <Form.Control.Feedback type="invalid">
            {errors.AnioModeloVM}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>

      {/* Seguros */}
      <Row className="mb-3">
        <Form.Group as={Col} md="6" controlId="AseguraRespCivil">
          <Form.Label>Aseguradora Responsabilidad Civil</Form.Label>
          <Select
            placeholder="Seleccione aseguradora"
            options={insurers}
            value={values.AseguraRespCivil}
            onChange={(option) => {
              formik.setFieldValue("AseguraRespCivil", option);
            }}
            onBlur={() => formik.setFieldTouched("AseguraRespCivil", true)}
            className={
              errors.AseguraRespCivil && touched.AseguraRespCivil
                ? "is-invalid"
                : ""
            }
          />
          {errors.AseguraRespCivil && touched.AseguraRespCivil && (
            <div className="invalid-feedback d-block">
              {errors.AseguraRespCivil}
            </div>
          )}
        </Form.Group>
        <Form.Group as={Col} md="6" controlId="PolizaRespCivil">
          <Form.Label>Póliza Responsabilidad Civil</Form.Label>
          <Form.Control
            name="PolizaRespCivil"
            value={values.PolizaRespCivil || ""}
            onChange={handleChange}
            isInvalid={touched.PolizaRespCivil && !!errors.PolizaRespCivil}
          />
          <Form.Control.Feedback type="invalid">
            {errors.PolizaRespCivil}
          </Form.Control.Feedback>
        </Form.Group>
      </Row>
    </>
  );
};

export default AutotransporteFormFields;
